import { useEffect, useCallback } from 'react'
import * as QueryString from 'query-string'
import { useDispatch } from 'react-redux'
import { post, URL_VARIABLES } from 'services/api'
import { setToken } from 'redux/reducers/token'

import { verifyTokenRole } from 'config/tokenRouter'

export default ({ location, history }) => {

  const params = QueryString.parse(location.search)
  const dispatch = useDispatch()
  
  if (!params.signature) {
    history.replace({
      pathname: '/forbidden',
      state: { error: 'Link inválido!' },
    })
    return null
  }

  const verifySig = useCallback(
    async (signature) => {
      try {
        const { data } = await post({
          url: '/onboarding/validate',
          data: { signature },
          source: URL_VARIABLES.ANTIFRAUDE,
        })
        
        const { token } = data
        
        dispatch(setToken(token))
        return verifyTokenRole(token, history, null, {})

      } catch (e) {
        let state = {}
        if (e.response) {
          state = {
            error: e.response.data.detail,
            redirect: e.response.data.redirect_url,
          }
        } else {
          state = {
            error: 'Houve um problema na requisicao',
          }
        }

        history.replace({
          pathname: '/forbidden',
          state: state,
        })
      }
      return null
    },
    [dispatch, history],
  )

  useEffect(() => {
    verifySig(params.signature)
  }, [params.signature, verifySig])

  return null
}
